<template>
  <el-dialog :title="'客訴事件'" :visible.sync="isShowDialog" @close="onClose">
    <el-form
      :model="updateComplainForm"
      :rules="rules"
      label-width="120px"
      label-position="left"
      ref="updateComplainForm"
      class="update-complain-form"
    >
      <!-- form row-1 -->
      <el-row>
        <el-col :span="11">
          <el-form-item label="司機" prop="driverLabel">
            <el-autocomplete
              v-model="updateComplainForm.driverLabel"
              :fetch-suggestions="querySearchAsync"
              placeholder="請輸入司機隊編/呼號"
              @select="onSelectDriver"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="客服種類" prop="typeId">
            <el-select v-model="updateComplainForm.typeId" clearable>
              <el-option
                v-for="type in vx_typeList"
                :key="type.id"
                :label="type.name"
                :value="type.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!--form row-2-->
      <el-row>
        <el-col :span="11">
          <el-form-item label="事件發生時間" prop="happenTime">
            <el-date-picker
              v-model="updateComplainForm.happenTime"
              type="datetime"
              placeholder="事件發生時間"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="處理進度" prop="status">
            <el-select v-model="updateComplainForm.status">
              <el-option
                v-for="status in COMPLAIN_STATUS"
                :key="status.key"
                :label="status.label"
                :value="status.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!--form row-3-->
      <el-row>
        <el-col :span="11">
          <el-form-item label="立案人員" prop="createPersonName">
            <el-select
              v-model="updateComplainForm.createPersonName"
              :disabled="true"
            >
              <el-option
                v-for="manager in managerList"
                :key="manager.id"
                :label="manager.managerName"
                :value="manager.managerName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="客服建立時間" prop="createdAt">
            <el-date-picker
              v-model="updateComplainForm.createdAt"
              :disabled="true"
              type="datetime"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- form row-4 -->
      <el-row>
        <el-col :span="11">
          <el-form-item label="結案人員" prop="sealPersonId">
            <el-select
              v-model="updateComplainForm.sealPersonId"
              placeholder="請選擇結案人員"
              clearable
            >
              <el-option
                v-for="manager in managerList"
                :key="manager.id"
                :label="manager.managerName"
                :value="manager.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="結案時間" prop="finishTime">
            <el-date-picker
              v-model="updateComplainForm.finishTime"
              type="datetime"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- form textarea-1 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="事件內容" prop="eventContent">
            <el-input
              type="textarea"
              placeholder="請輸入事件內容"
              v-model="updateComplainForm.eventContent"
              :autosize="{ minRows: 3 }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- form textarea-2 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="處理描述" prop="processingDesc">
            <el-input
              type="textarea"
              placeholder="請輸入處理描述"
              v-model="updateComplainForm.processingDesc"
              :autosize="{ minRows: 3 }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!--last update time-->
      <el-form-item label="最後處理時間" prop="lastTime">
        <el-date-picker
          v-model="updateComplainForm.lastTime"
          :disabled="true"
          type="datetime"
        />
      </el-form-item>
    </el-form>
    <!-- form footer  -->
    <span slot="footer" class="dialog-footer">
      <el-button
        :loading="isUpdateBtnLoading"
        type="primary"
        @click="onSubmit('updateComplainForm')"
      >
        更新
      </el-button>
      <el-button :loading="isDeleteBtnLoading" type="danger" @click="onDelete">
        封存
      </el-button>
      <el-button @click="onClose">關閉</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { reqUpdateComplain, reqDeleteComplain } from '@/api/customerComplain'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { complainStatus } from '@/constants/customerComplain'
import dayjs from 'dayjs'
import { cookies } from '@/utils/cookies'
import { Notification } from 'element-ui'

export default {
  data() {
    return {
      currentLoginServiceId: null,
      isUpdateBtnLoading: false,
      isDeleteBtnLoading: false,
      updateComplainForm: {
        /* 司機 */
        driverId: null,
        driverLabel: null,
        /* 客服種類 */
        typeId: null,
        /* 事件發生時間 */
        happenTime: '',
        /* 客服建立時間 */
        createdAt: '',
        /* 結案時間 */
        finishTime: '',
        /* 最後處理時間 */
        lastTime: '',
        /* 處理進度 */
        status: 0,
        /* 立案人員 */
        createPersonName: null,
        /* 結案人員 */
        sealPersonId: null,
        /* 事件內容 */
        eventContent: '',
        /* 處理描述 */
        processingDesc: '',
      },
      rules: {
        driverLabel: [
          {
            required: true,
            message: '請選擇司機',
            trigger: 'change',
          },
        ],
        typeId: [
          {
            required: true,
            message: '請選擇客服種類',
            trigger: 'change',
          },
        ],
        happenTime: [
          {
            type: 'date',
            required: true,
            message: '請選擇事件發生時間',
            trigger: 'change',
          },
        ],
        createPersonName: [
          {
            required: true,
            message: '請選擇立案人員',
            trigger: 'change',
          },
        ],
        eventContent: [
          {
            required: true,
            message: '請撰寫事件內容',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    ...mapActions('managerStore', {
      vx_fetchComplainList: 'fetchComplainList',
    }),
    ...mapMutations('managerStore', {
      vx_setIsUpdateComplainDialog: 'SET_IS_UPDATE_COMPLAIN_DIALOG',
    }),
    onSubmit(formName) {
      /* 若是處理進度為未處理或處理中，將完成時間清空 */
      if (this.updateComplainForm.status !== 2) {
        this.updateComplainForm.finishTime = ''
      }
      /* 若沒有針對客訴事件修改，則無須發送request */
      let isUpdate = false
      for (const k in this.updateComplainForm) {
        if (this.vx_updateComplainDialog.hasOwnProperty(k)) {
          let v1 = this.vx_updateComplainDialog[k]
          let v2 = this.updateComplainForm[k]
          /* 若是Date object須轉換為milliseconds再做比較 */
          if (
            this.updateComplainForm[k] instanceof Date &&
            this.vx_updateComplainDialog[k] instanceof Date
          ) {
            v1 = v1.getTime()
            v2 = v2.getTime()
          }
          /* 比較 */
          if (v1 !== v2) {
            isUpdate = true
            break
          }
        }
      }
      if (!isUpdate) {
        Notification({
          type: 'warning',
          message: '無任何修改，請勿點擊更新',
        })
        return
      }
      /* 表單校驗 */
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.isUpdateBtnLoading = true
            const {
              driverId,
              typeId,
              createPersonName,
              sealPersonId,
              eventContent,
              processingDesc,
              status,
              happenTime,
              finishTime,
            } = this.updateComplainForm
            const { success } = await reqUpdateComplain(
              this.vx_updateComplainId,
              {
                driver_id: driverId,
                type_id: typeId,
                customer_id:
                  this.vx_currentLoginServiceId /* 目前登入後台的客服id */,
                update_service: createPersonName /* 立案人員姓名 */,
                finishCustomerServiceId: sealPersonId /* 結案人員id */,
                /* 配合server調整為+0時區 */
                finishTime: finishTime
                  ? dayjs(finishTime)
                      .subtract(8, 'hour')
                      .format('YYYY-MM-DD HH:mm:ss')
                  : null,
                /* 配合server調整為+0時區 */
                event_time: dayjs(happenTime)
                  .subtract(8, 'hour')
                  .format('YYYY-MM-DD HH:mm:ss'),
                event_content: eventContent,
                processing_description: processingDesc,
                status: status,
                code: cookies.get('GladTeamCode'),
              },
            )
            if (success) {
              Notification({
                type: 'success',
                message: '更新客訴單成功',
              })
              this.resetForm()
              this.vx_fetchComplainList()
              this.vx_setIsUpdateComplainDialog(false)
            } else {
              Notification({
                type: 'error',
                message: '更新客訴單失敗',
              })
            }
          } catch (e) {
            console.error(e)
            Notification({
              type: 'error',
              message: '更新客訴單失敗',
            })
          } finally {
            this.isUpdateBtnLoading = false
          }
        } else {
          Notification({
            type: 'warning',
            message: '請完整輸入表單資訊',
          })
          return false
        }
      })
    },
    async onDelete() {
      try {
        this.isDeleteBtnLoading = true
        const { success } = await reqDeleteComplain(this.vx_updateComplainId, {
          customer_id: this.vx_currentLoginServiceId,
          service_name: cookies.get('GladName'),
        })
        if (success) {
          Notification({
            type: 'success',
            message: '封存成功',
          })
          this.vx_fetchComplainList('afterDelete')
          this.vx_setIsUpdateComplainDialog(false)
        } else {
          Notification({
            type: 'error',
            message: '封存失敗',
          })
        }
      } catch (e) {
        console.error(e)
        Notification({
          type: 'error',
          message: '封存失敗',
        })
      } finally {
        this.isDeleteBtnLoading = false
      }
    },
    initForm() {
      /* deep clone表單的初始狀態 */
      this.updateComplainForm = structuredClone(this.vx_updateComplainDialog)
      /* 處理進度=處理完成，結案時間顯示最後處理時間 */
      if (this.updateComplainForm.status === 2) {
        this.updateComplainForm.finishTime = this.updateComplainForm.lastTime
      } else {
        /* 不是則會帶入當下時間 */
        this.updateComplainForm.finishTime = new Date()
      }
    },
    resetForm() {
      /* HACK: 或許有更好的方法，目前作法清除了表單資料2次 */
      this.$refs['updateComplainForm'].resetFields()
      this.updateComplainForm = {
        driverId: null,
        driverLabel: null,
        typeId: null,
        happenTime: null,
        status: 0,
        createPersonName: null,
        createdAt: null,
        sealPersonId: null,
        finishTime: null,
        eventContent: '',
        processingDesc: '',
        lastTime: null,
      }
    },
    onClose() {
      this.vx_setIsUpdateComplainDialog(false)
    },
    /* 司機動態搜尋 */
    querySearchAsync(queryString, cb) {
      const filterdResults = queryString
        ? this.vx_driverList.filter(this.driverFilter(queryString))
        : this.vx_driverList
      const results = filterdResults.map((driver) => {
        return {
          value: `${driver.call_number}-${driver.name}`,
          id: String(driver.id),
        }
      })
      cb(results)
    },
    driverFilter(queryString) {
      return (state) =>
        state.call_number.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    },
    onSelectDriver({ id }) {
      this.updateComplainForm.driverId = id
    },
  },
  computed: {
    ...mapGetters('managerStore', {
      managerList: 'getManagerList',
      getUpdateComplainDialog: 'getUpdateComplainDialog',
    }),
    ...mapState('managerStore', {
      vx_isUpdateComplainDialog: 'isUpdateComplainDialog',
      vx_updateComplainId: 'updateComplainId',
      vx_updateComplainDialog: 'updateComplainDialog',
      vx_driverList: 'driverList',
      vx_typeList: 'typeList',
      vx_currentLoginServiceId: 'currentLoginServiceId',
    }),
    isShowDialog: {
      get() {
        return this.vx_isUpdateComplainDialog
      },
      set(value) {
        this.vx_setIsUpdateComplainDialog(value)
      },
    },
  },
  created() {
    /* 更新客訴管理dialog，處理進度不出現全部的選項 */
    this.COMPLAIN_STATUS = complainStatus.slice(0, complainStatus.length - 1)
    this.unwatch = this.$store.watch(
      (state) => state.managerStore.isUpdateComplainDialog,
      (isOpen) => {
        /* 若是開啟dialog的情況，初始化表單的既有資料 */
        if (isOpen) {
          this.initForm()
        }
      },
    )
  },
  beforeDestroy() {
    this.unwatch()
  },
}
</script>

<style scoped>
.el-form-item {
  width: 100%;
}

.el-date-picker {
  width: 100%;
}

.el-date-editor.el-input {
  width: 100%;
}

.el-col {
  margin-right: 20px;
}

.el-col:last-child {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/components/UpdateComplainDialog.vue